import { render, staticRenderFns } from "./WidgetPlaceholder.vue?vue&type=template&id=5df80116&functional=true"
import script from "./WidgetPlaceholder.vue?vue&type=script&lang=js"
export * from "./WidgetPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./WidgetPlaceholder.vue?vue&type=style&index=0&id=5df80116&prod&module=true&lang=less"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  injectStyles,
  null,
  null
  
)

export default component.exports